import React, { Component } from 'react'
import { connect } from 'react-redux'
import { RouteKey } from '@internal/route'
import { DeliveryShared } from '@shared/Pages'
import { CreateHocLazy } from '@lib/ReduxBase'
import { CreateRoutePath } from '@lib/RouteBase'
import { ActionPannel, CRUDPannel } from '@lib/Table'
import { EMediaType, IMediaDelivery } from '@shared/Types'
import { IMediaQueryParam } from '@shared/Services/QueryParamService'
import UIStyleds from '@shared/UIStyleds'
import { GetTable } from './configs'
import { IDeliveryReduxProps } from './redux.types'
import { mapDispatchToProps, mapStateToProps } from './redux.map'

const TableInstance = GetTable()

interface IProps extends IDeliveryReduxProps {}
class ViewBase extends Component<IProps> {
  render() {
    return (
      <UIStyleds.WrapProfile>
        <TableInstance
          ReduxOption={this.props.slice.tableInfo}
          onChange={this.props.onChangeTableInfo}
          CRUDPannel={() => (
            <CRUDPannel
              Title='Deliveries'
              Create={
                <DeliveryShared.FormCreate
                  onSubmit={async (value) => {
                    await this.props.CRUD.Create(value)
                  }}
                />
              }
            />
          )}
          ActionPannel={(p) => {
            const data = p.data as IMediaDelivery
            const routeKey = data.MediaType === EMediaType.Youtube ? RouteKey.DeliveryYoutubeDetail : RouteKey.DeliveryMediaDetail
            const href = CreateRoutePath<IMediaQueryParam>([RouteKey.Profile, routeKey], { query: { deliveryId: data.Id } })
            return <ActionPannel Buttons={{ ExtendBefore: [<DeliveryShared.UIBtnDetailClient href={href} />] }} />
          }}
        />
      </UIStyleds.WrapProfile>
    )
  }
}

export * from './redux.thunks'

export { default as DeliverySlice } from './redux.slice'

const HocLazyInstace = CreateHocLazy(ViewBase)

export const DeliveryMapRedux = connect(mapStateToProps, mapDispatchToProps)(HocLazyInstace)

interface IDeliveryStatusProps extends IDeliveryReduxProps {
  data?: Partial<IMediaDelivery>
  onChangeValue?: (id: string, value: Partial<IMediaDelivery>) => Promise<void>
}

const DeliveryStatus: React.FC<IDeliveryStatusProps> = (props) => (
  <DeliveryShared.UIBtnStatus
    data={props.data}
    onChangeValue={async (i, v) => {
      await props.CRUD.Update(i, v)
      props.onChangeValue && (await props.onChangeValue(i, v))
    }}
  />
)

export const DeliveryStatusMapRedux = connect(mapStateToProps, mapDispatchToProps)(DeliveryStatus)
